import { Box, Flex, Image, Text } from '@chakra-ui/react'
import { Section } from '@/components/layout'
import { SectionLabel } from '@/components/typography'
import { useLocale } from '@/i18n'
import { ABOUT_COPY } from './about.data'

export const About = () => {
  const { locale } = useLocale()
  const about = ABOUT_COPY[locale]

  return (
    <Section id="studio">
      <SectionLabel mb="40px">{about.sectionLabel}</SectionLabel>
      <Flex flexWrap="wrap" gap="clamp(32px, 4vw, 64px)" alignItems="flex-start">
        <Box as="figure" flex="0 1 300px">
          <Image
            src="/profile.jpg"
            alt={about.founderImageAlt}
            w="100%"
            maxW="300px"
            aspectRatio="5 / 6"
            objectFit="cover"
            filter="grayscale(1) contrast(1.08)"
          />
          <Text
            as="figcaption"
            mt="10px"
            fontSize="11px"
            letterSpacing="0.14em"
            textTransform="uppercase"
          >
            {about.founderCaption}
          </Text>
        </Box>
        <Box flex="1 1 420px" minW="0">
          <Text
            mb="32px"
            fontFamily="heading"
            fontWeight="800"
            fontSize="clamp(22px, 2vw, 30px)"
            lineHeight="1.24"
            letterSpacing="-0.025em"
          >
            {about.studioLine}
          </Text>
          <Box h="2px" bg="divider" mb="24px" />
          <Text mb="12px" fontFamily="heading" fontWeight="800" fontSize="17px">
            {about.foundedByLine}
          </Text>
          <Text mb="16px" fontSize="15px" lineHeight="1.62" maxW="88ch">
            {about.founderBio}
          </Text>
          <Text fontSize="15px" lineHeight="1.62" maxW="88ch" color="muted">
            {about.personalNote}
          </Text>
        </Box>
      </Flex>
    </Section>
  )
}
